import React from "react";

import { ReactSVG } from "react-svg";
import CheckinIcon from "../../../images/web-checkin.svg";

export default function FormBox({title, children}) {

  return (
    <>
      <div className="heading-box">
        <h1>{title}</h1>
        <div className="login-wrap">
          <ReactSVG src={CheckinIcon} className="login-icon" />
          <span>Travel Agent</span>
        </div>
      </div>
      <hr />
      {children}
    </>
  );

}

